// WhatsApp Click-to-Chat utility with template variable replacement.

export type TemplateVars = {
  client_name?: string;
  advertiser_name?: string;
  listing_title?: string;
  listing_area?: string;
  listing_price?: string;
  listing_url?: string;
  property_id?: string;
};

export const cleanWhatsAppNumber = (phone: string) => {
  let n = (phone ?? "").replace(/[^\d]/g, "");
  // Strip leading zeros (00... country prefix or domestic 0)
  while (n.startsWith("0")) n = n.slice(1);
  return n;
};

export const fillTemplate = (template: string, vars: TemplateVars) =>
  template.replace(/\{(\w+)\}/g, (_m, key: string) => {
    const v = (vars as Record<string, string | undefined>)[key];
    return v ?? "";
  });

export const buildWhatsAppUrl = (phone: string, message: string) => {
  const num = cleanWhatsAppNumber(phone);
  return `https://wa.me/${num}?text=${encodeURIComponent(message)}`;
};

export const openWhatsAppChat = (phone: string, message: string) => {
  const url = buildWhatsAppUrl(phone, message);
  window.open(url, "_blank", "noopener,noreferrer");
};

export const buildPublicListingUrl = (id: string) => `${window.location.origin}/listings/${id}`;
